import axios, { AxiosResponse } from 'axios';
import config, { getAuthHeaders } from '../config';

/**
 * Update user notification preferences
 */
export const updateUserNotificationPreference = async (params: {
    allowedServiceNotifications: string[];
    showOnlyUnread: boolean;
}): Promise<AxiosResponse> => {
    const url = `${config.api.baseUrl}${config.api.endpoints.updateUserPreference}`;
    return axios.post(url, params, { headers: getAuthHeaders() });
};

/**
 * Get Firebase authentication token from backend
 */
export const getNotificationAuthToken = async (): Promise<AxiosResponse> => {
    const url = `${config.api.baseUrl}${config.api.endpoints.getNotificationAuthToken}`;
    return axios.get(url, { headers: getAuthHeaders() });
};
